<template>
    <div class="card my-1">
        <div class="card-body">
            <div class="bs-component"></div>
            <div class="col-lg-12 d-flex flex-row">
                <h5>
                    <span class="text-primary">{{ $t("title.em.workflow.task.complete") }}</span>
                    <b-spinner v-if="status === undefined" class="ml-2" small></b-spinner>
                    <span v-else class="ml-2">{{ taskConfig.name }}</span>
                </h5>
                <div class="ml-auto">
                    <template v-if="taskConfig.viewInfos">
                        <template v-for="(item,index) of taskConfig.viewInfos">
                            <overlay-mini-table :id="item.id"
                                                :key="index"
                                                :entity-name="item.entityName"
                                                :title="item.title">
                            </overlay-mini-table>
                        </template>
                    </template>
                    <slot :status="status" :tags="taskConfig.tag" name="customAction"></slot>
                </div>
            </div>
        </div>
        <div v-if="status !== undefined && currentBusinessData.workflowTask !== undefined"
             class="ml-5 mb-2 mr-2">
            <div v-if="hasInit" class="d-flex flex-wrap row">
                <template v-for="(item,index) of taskConfig.variables">
                    <template v-if="checkVariableShow(item)">
                        <mini-table v-if="item.type===VALUE_TYPE.TABLE"
                                    :key="index"
                                    :ref="'Table' + index"
                                    :custom-vuex-name="item.customVuexName"
                                    :enable-query-data="item.disableAutoSave"
                                    :entity-name="item.entityName"
                                    :fields="item.fields"
                                    :filter-holder="item.filterHolder"
                                    :header-title="item.label"
                                    :items="item.initData ? value[index] : item.rows"
                                    :need-model-fields="item.needModelFields"
                                    :read-only="item.disableAutoSave"
                                    :save-holder="item.saveHolder"
                                    class="col-12 mt-1"
                                    @dataChange="tableDataChange(index, $event)">
                        </mini-table>
                        <diverse-input
                            v-else
                            :key="index"
                            :ref="'DI' + index"
                            :config="item"
                            :value.sync="value[index]"
                            class="col-4"
                            @tagChange="handleTagChange"
                        ></diverse-input>
                    </template>
                </template>

                <diverse-input
                    v-if="taskConfig.withComment || taskConfig.withCommentNotNull"
                    key="-1"
                    ref="comment"
                    :config="commentConfig"
                    :value.sync="taskForm.comment"
                    class="col-4"
                ></diverse-input>
            </div>
            <div class="row mt-2 d-flex flex-column">
                <em-attachment
                    v-if="(taskConfig.withAttachment || taskConfig.withAttachmentNotNull) && attachmentAvailable"
                    :avoid-null="!taskConfig.withAttachmentNotNull"
                    class="col-4 w-100"
                    isEditing
                    @idsChanged="handleIdsChanged"
                ></em-attachment>
                <api-check-validation v-if="apiCheckValidationAvailable"
                                      ref="api_check"
                                      :api="taskConfig.needCheck.api"
                                      :label="taskConfig.needCheck.label"
                                      :read-only="taskConfig.needCheck.readOnly" class="ml-1"
                                      @change="refreshTagCount--"></api-check-validation>
                <div class="d-flex flex-row">
                    <div v-if="userSelect && userSelect.length > 0" class="d-flex flex-row col-4 mh_">
                        <template v-for="(item,index) of userSelect">
                            <b-button :key="index"
                                      :class="index > 0 ? 'ml-1' : ''"
                                      :disabled="item.loading"
                                      :title="generateTitle(item)"
                                      class="col"
                                      variant="outline-secondary"
                                      @click="openUserSelectModal(index)">
                                <b-spinner v-show="item.loading" small></b-spinner>
                                <span v-if="item.userIds == null || item.userIds === ''">
                                    {{
                                        item.labelWithout === undefined ? '指 派' + (item.label === undefined ? '' : ' ' + item.label) : item.labelWithout
                                    }}
                                </span>
                                <span v-else>
                                    {{ item.labelWithout === undefined ? '已指派' : item.labelWithout }}:
                                    {{ item.userList[0].deptName }}-{{ item.userList[0].name }}
                                    {{ item.userList.length > 1 ? '等' : '' }}
                                </span>
                            </b-button>
                        </template>
                    </div>
                    <b-button :disabled="taskCompleteLoading || !isComplete" class="ml-1 mh_ col-4"
                              variant="outline-success"
                              @click="completeTask">
                        <b-spinner v-show="taskCompleteLoading" small></b-spinner>
                        提 交
                    </b-button>
                    <mini-button class="ml-1 mh_" variant="outline-secondary" @btnClick="goBackNormal"
                                 name="取消处理，返回上一页面">
                        <i class="fa-solid fa-reply"></i>
                    </mini-button>
                    <KeyValueCell v-if="nextTask !== ''" :value="nextTask" class="m-auto-l-0 mh_" horizontal>下一任务
                    </KeyValueCell>
                </div>
            </div>
        </div>

        <div v-else-if="currentBusinessData.workflowTask === undefined && status !== undefined">
            任务未领取
        </div>
        <b-modal v-model="userSelectModalVisible" scrollable title="处理人选择" @ok="handleAssignSelect">
            <dept-user-tree v-if="userSelect.length > userSelectIndex" ref="deptUserTree"
                            :dept-id="userSelect[userSelectIndex].deptId"
                            :selected-id="userSelect[userSelectIndex].userIds"></dept-user-tree>
        </b-modal>
    </div>
</template>

<script>
import DiverseInput from "@/components/workflow/stuffs/DiverseInput";
import EmAttachment from "@/components/em/EmAttachment";
import workflowTaskMixins, {WITHOUT_ATTACHMENT_TAG} from "@/components/workflow/mixin/WorkflowTaskMixins";
import EmCommonApi from "@/mixin/em/common/api";
import DeptUserTree from "@/components/em/EmBusiness/deptUserTree";
import KeyValueCell from "@/views/sithMes/prd/PrdOperationExcute/cells/KeyValueCell";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import OverlayMiniTable from "@/components/workflow/stuffs/OverlayMiniTable";
import ApiCheckValidation from "@/components/workflow/stuffs/ApiCheckValidation.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";

export default {
    name: "WorkflowTaskComplete",
    mixins: [workflowTaskMixins, EmCommonApi, emCommonUtilMixin],
    components: {
        MiniButton,
        ApiCheckValidation,
        OverlayMiniTable,
        MiniTable,
        KeyValueCell,
        DeptUserTree,
        EmAttachment,
        DiverseInput
    },
    props: {
        config: Object,
        taskId: {
            type: String
        },
        status: {
            required: true
        },
        callbackApi: String,
        businessKey: Number,
        businessData: Object,
        completeApi: String,
        //自定义完成任务
        useSelfCompleteTask: {
            type: Boolean,
            default: false
        },
        //自定义完成任务回调
        useSelfCompleteFeedback: {
            type: Boolean,
            default: false
        },
        needPreValues: {
            type: Boolean,
            default: false
        },
        needBusinessKey: {
            type: Boolean,
            default: false
        },
        syncValueChange: {
            type: Boolean,
            default: false
        },
        //多任务模式
        multiTask: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            value: [],
            taskForm: {
                taskId: this.taskId,
                approved: 0,
                comment: null,
                attachmentIds: null,
                variables: null,
                taskAssigneeMap: {},
                callbackApi: ''
            },
            hasInit: false,
            taskCompleteLoading: false,
            needAssignee: false,
            postData: {},
            approveIndex: -1,
            userSelect: [],
            userSelectIndex: 0,
            userSelectModalVisible: false,

            userInfosMap: new Map(),
            variableIndex: {},
            refreshTagCount: 0,
        }
    },
    computed: {
        taskConfig() {
            return this.getTaskConfig(this.status);
        },
        isComplete() {
            if (this.value) {
                //refresh
            }
            if (this.refreshTagCount) {
                //refresh
            }
            if (this.hasInit) {
                return this.checkComplete();
            }
            return false;
        },
        approve() {
            if (this.value) {
                console.log()
            }
            return this.approveIndex >= 0 ? this.value[this.approveIndex] : 0;
        },
        savedApprove() {
            return this.getApprove();
        },
        nextTask() {
            return this.getTaskNameByTaskId();
        },
        nextTaskId() {
            return this.getNextTaskByApprove();
        },
        nextTaskConfig() {
            let temp = this.initializedConfig[this.nextTaskId];
            if (temp === undefined) {
                return {};
            }
            return temp;
        },
        completeApiFinal() {
            if (this.useSelfCompleteTask) {
                return this.$_selfCompleteApi;
            }
            return this.hasOtherCompleteApi ? this.completeApi : process.env.VUE_APP_EM_WORKFLOW_URL + "/completeTask";
        },
        hasOtherCompleteApi() {
            return this.hasCode(this.completeApi);
        },
        completeFeedbackApi() {
            return this.useSelfCompleteFeedback ? this.$_selfCompleteFeedbackApi : this.callbackApi;
        },
        attachmentAvailable() {
            if (this.refreshTagCount) {
                //to refresh
            }
            return !this.containsTag(WITHOUT_ATTACHMENT_TAG);
        },
        apiCheckValidationAvailable() {
            if (this.refreshTagCount) {
                //to refresh
            }
            let needCheck = this.taskConfig.needCheck;
            if (needCheck instanceof Object) {
                if (needCheck.hasOwnProperty('activateByTag')) {
                    return this.containsTag(needCheck.activateByTag);
                }
                return true;
            }
            return false;
        },
        currentBusinessData() {
            if (this.multiTask) {
                let temp = {
                    workflowTask: {}
                };
                return this.businessData ? this.businessData : temp;
            } else {
                return this.$store.state[this.modelName].processBusinessData;
            }
        },
    },
    watch: {
        approve: {
            deep: true,
            handler(val, oldVal) {
                if (val !== oldVal || this.status && this.approveIndex < 0) {
                    this.handleApproveChange();
                }
            },
            immediate: true
        },
        savedApprove() {
            this.handleApproveChange();
        },
        status: {
            handler() {
                this.initData();
            },
            immediate: true
        },
        taskLocalVariables() {
            this.initUserSelectMap();
        }
    },
    mounted() {
        // this.initData();
    },
    methods: {
        initData() {
            this.initConfig(this.taskConfig);
            this.checkNeedAssignee();
            //寻找approve
            for (let i = 0; i < this.taskConfig.variables.length; i++) {
                let item = this.taskConfig.variables[i];
                if (item.name)
                    this.variableIndex[item.name] = i;//记录index
                if (item.saveTo === this.SAVE_TO.APPROVE) {
                    item.require = true;
                    this.approveIndex = i;
                }
                let temp = '';
                //如果需要初始化数据
                if (item.initData === true) {
                    let initName = this.getDataFieldName(item);
                    if (this.currentBusinessData.hasOwnProperty(initName)) {
                        temp = this.currentBusinessData[initName];
                        if (item.type === this.VALUE_TYPE.TABLE && this.hasCode(temp)) {
                            temp = JSON.parse(temp);
                        }
                    }
                }
                this.value.push(temp);
            }
            this.hasInit = true;
            this.globalChangeTag();
            this.$forceUpdate();
        },
        //提交完成任务
        completeTask() {
            this.taskCompleteLoading = true;
            if (this.isComplete) {
                if (this.taskForm.variables == null) {
                    this.taskForm.variables = {};
                }
                let variables = this.taskConfig.variables;
                let needPostData = false;
                let needSavedTable = [];
                //approval变量二次设值
                this.taskForm.approved = this.getApprove();
                //装载各类字段
                for (let i = 0; i < variables.length; i++) {
                    let temp = variables[i];
                    this.taskForm.variables[temp.name] = this.value[i];
                    //approve with name
                    if (temp.saveTo === this.SAVE_TO.APPROVE && temp.name !== undefined) {
                        let val = '#@';
                        if (temp.hasOwnProperty('toDatabase')) {
                            val = temp.toDatabase(this.taskForm.approved);
                        }
                        if (val !== '#@') {
                            this.postData[temp.name] = temp.hasOwnProperty('toDatabase') ? val : this.value[i];
                            needPostData = true;
                        }
                    }
                    if (this.checkVariableShow(temp)) {
                        //to database
                        if (temp.saveTo === this.SAVE_TO.DATABASE) {
                            let saveName = this.getDataFieldName(temp);
                            if (temp.type === this.VALUE_TYPE.TABLE) {
                                this.postData[saveName] = JSON.stringify(this.$refs['Table' + i][0].columnEditData(true));
                            } else {
                                this.postData[saveName] = this.value[i];
                            }
                            needPostData = true;
                        }
                        if (temp.type === this.VALUE_TYPE.TABLE && !temp.disableAutoSave) {
                            needSavedTable.push(i);
                        }
                    }
                }
                //自定义添加流程变量
                if (this.taskConfig.hasOwnProperty('addVariableByApprove')) {
                    let variable = this.taskConfig.addVariableByApprove(this.taskForm.approved);
                    if (variable !== undefined && variable.hasOwnProperty('name')) {
                        this.taskForm.variables[variable.name] = variable.value;
                        if (this.taskConfig.copyToData === true) {
                            this.postData[variable.name] = variable.value;
                            needPostData = true;
                        }
                    }
                }
                //自定义修改database
                if (this.taskConfig.hasOwnProperty('postDataByApprove')) {
                    let variable = this.taskConfig.postDataByApprove(this.taskForm.approved);
                    if (variable !== undefined && variable.hasOwnProperty('name')) {
                        this.postData[variable.name] = variable.value;
                        needPostData = true;
                    }
                }
                //attachments save to database
                if (this.taskConfig.hasOwnProperty('attachmentSaveTo')) {
                    let name = this.taskConfig.attachmentSaveTo;
                    this.postData[name] = this.taskForm.attachmentIds;
                    needPostData = true;
                }
                //任务处理人
                if (this.checkNeedAssignee()) {
                    for (let item of this.userSelect) {
                        let loginNames = this.generateUserListLoginName(item.userList);
                        let assigneeMapByApprove = this.getAssigneeMapByApprove();
                        let itemConfig = assigneeMapByApprove.find(o => o.name === item.name);
                        if (itemConfig) {
                            if (itemConfig.isAssignee) {//notice: 如果是assignee，系统会自动拼接"_assignee"
                                this.taskForm.taskAssigneeMap[item.name] = loginNames;
                            } else {
                                this.taskForm.variables[item.name] = loginNames;
                            }
                            //是否保存至业务表
                            if (itemConfig.saveToDatabase) {
                                this.postData[itemConfig.saveName ? itemConfig.saveName : item.name] = loginNames;
                                needPostData = true;
                            }
                        }
                    }
                }
                //增加字段
                if (this.needPreValues) {
                    this.taskForm.fromTask = this.status;
                    this.taskForm.nextTask = this.nextTaskId;
                    this.taskForm.taskUserKey = this.getDefaultTaskUser();
                    this.taskForm.processInstanceBusinessKey = this.businessKey;
                }
                if (this.needBusinessKey) {
                    this.taskForm.processInstanceBusinessKey = this.businessKey;
                }
                //设置完成回调接口地址
                this.taskForm.callbackApi = this.completeFeedbackApi;
                let tempForm = this.deepCopyObj(this.taskForm);
                if (this.syncValueChange) {
                    let requests = this.syncRequest(needPostData, needSavedTable);
                    if (requests.length > 0) {
                        tempForm.requests = requests;
                        tempForm.undoCallbackApi = this.$_defaultUndoFeedbackApi;
                    }
                }
                if (this.multiTask) {
                    this.$emit('complete', {
                        api: this.completeApiFinal,
                        form: tempForm
                    });
                    this.finallyComplete();
                } else {
                    this.$_emApiMixin_post(this.completeApiFinal, tempForm).then(response => {
                        console.log(response.data);
                        if (!this.syncValueChange) {
                            this.afterComplete(needPostData, needSavedTable);
                        }
                        this.$message.success("提交成功");
                        this.goBackNormal();
                    }).finally(() => this.finallyComplete());
                }
            }
        },
        finallyComplete() {
            this.taskCompleteLoading = false;
            if (this.syncValueChange) {
                this.postData = {};
            }
        },
        syncRequest(needPostData, needSavedTable) {
            let requests = [];
            if (needPostData) {
                this.postData.id = this.businessKey;
                let temp = {
                    url: `${this.$_emApiMixin_moduleBaseApi(this.modelName)}/${this.modelName}/selective`,
                    httpType: 'put',
                    entity: this.postData
                }
                if (this.multiTask) {
                    temp.needId = true;
                }
                requests.push(temp);
            }
            //接口调用post
            if (this.taskConfig.hasOwnProperty('postByApprove')) {
                let postByApprove = this.taskConfig.postByApprove(this.taskForm.approved, this.postData);
                if (postByApprove) {
                    postByApprove.httpType = 'post';
                    requests.push(postByApprove);
                }
            }
            //接口调用put
            if (this.taskConfig.hasOwnProperty('putByApprove')) {
                let putByApprove = this.taskConfig.putByApprove(this.taskForm.approved);
                if (putByApprove) {
                    putByApprove.httpType = 'put';
                    requests.push(putByApprove);
                }
            }
            //table save
            if (needSavedTable.length > 0) {
                needSavedTable.forEach(i => this.pushAll(this.$refs['Table' + i][0].getSaveRequest(), requests));
            }
            return requests;
        },
        afterComplete(needPostData, needSavedTable) {
            //修改业务表字段
            if (needPostData) {
                let api = `${this.$_emApiMixin_moduleBaseApi(this.modelName)}/${this.modelName}/selective`;
                this.postData.id = this.businessKey;
                this.$_emApiMixin_put(api, this.postData).finally(() => this.postData = {});
            }
            //接口调用post
            if (this.taskConfig.hasOwnProperty('postByApprove')) {
                this.$store.dispatch('api/post', this.taskConfig.postByApprove(this.taskForm.approved));
            }
            //接口调用put
            if (this.taskConfig.hasOwnProperty('putByApprove')) {
                this.$store.dispatch('api/put', this.taskConfig.putByApprove(this.taskForm.approved));
            }
            //table save
            if (needSavedTable.length > 0) {
                needSavedTable.forEach(i => this.$refs['Table' + i][0].saveTable());
            }
        },
        //检查提交条件是否完备
        checkComplete() {
            if (this.taskConfig.withAttachmentNotNull && this.attachmentAvailable && !this.hasCode(this.taskForm.attachmentIds)) {
                return false;
            }
            if (this.checkNeedAssignee() && !this.checkUserSelectComplete()) {
                return false;
            }
            if (this.apiCheckValidationAvailable) {
                if (!this.$refs.api_check || !this.$refs.api_check.isValidated()) {
                    return false;
                }
            }

            for (let i = 0; i < this.taskConfig.variables.length; i++) {
                if (this.checkVariableShow(this.taskConfig.variables[i]) && this.$refs['DI' + i] && this.$refs['DI' + i][0] && !this.$refs['DI' + i][0].isValidated()) {
                    return false;
                }
            }
            return true;
        },
        checkVariableShow(item) {
            if (item.needTag !== undefined) {
                let tagElement = this.taskConfig.tag[item.needTag];
                if (tagElement === false) {
                    if (item.type !== this.VALUE_TYPE.TABLE) {
                        if (item.initData === true) {
                            if (this.currentBusinessData.hasOwnProperty(item.name)) {
                                this.value[this.variableIndex[item.name]] = this.currentBusinessData[item.name];
                            }
                        } else {
                            this.value[this.variableIndex[item.name]] = '';
                        }
                    }
                }
                return tagElement === true;
            }
            return true;
        },
        containsTag(tag) {
            if (tag) {
                return this.taskConfig.tag[tag] === true;
            }
            return false;
        },
        hasCode(val) {
            return val !== undefined && val != null && val !== '';
        },
        handleIdsChanged(ids) {
            this.taskForm.attachmentIds = ids
        },
        handleTagChange(item) {
            if (item instanceof Array) {
                for (let pair of item) {
                    this.$set(this.taskConfig.tag, pair.name, pair.value);
                }
            } else {
                this.$set(this.taskConfig.tag, item.name, item.value);
            }
            this.refreshTagCount++;
            this.$forceUpdate()
        },
        openUserSelectModal(index) {
            this.userSelectIndex = index;
            this.userSelectModalVisible = true;
        },
        handleAssignSelect() {
            let userIds = this.$refs.deptUserTree.getUserIds();
            if (userIds.split(",").length > 1) {
                //是否允许多个
                if (!this.getAssigneeMapByApprove()[this.userSelectIndex].allowMulti) {
                    this.$message.error("您只能指定一个处理人");
                    return;
                }
            }
            if (userIds !== '') {
                this.getUserInfo(userIds);
            }
        },
        getUserInfo(userId) {
            let userSelectTemp = this.userSelect[this.userSelectIndex];
            userSelectTemp.loading = true;
            let api = process.env.VUE_APP_EM_ADMIN_URL + "/emAclUser/userInfo?userId=" + userId;
            this.$_emApiMixin_get(api).then(response => {
                userSelectTemp.userList = response.list;
                userSelectTemp.userIds = userId;
                userSelectTemp.loading = false;
            })
        },
        //检查是否需要赋值下一任务的处理人
        checkNeedAssignee() {
            this.needAssignee = this.taskConfig.hasOwnProperty('userSelectMap') && this.getAssigneeMapByApprove().length > 0;
            return this.needAssignee;
        },
        //获取approve
        getApprove() {
            let approve = -1;
            if (this.approveIndex >= 0 || this.taskConfig.forceApprove) {
                if (this.approveIndex >= 0) {
                    approve = this.value[this.approveIndex];
                }
                if (this.taskConfig.hasOwnProperty('setApproveBeforeSubmit')) {
                    approve = this.taskConfig.setApproveBeforeSubmit(approve);
                }
                if (this.taskConfig.hasOwnProperty('setApproveByBusinessData')) {
                    approve = this.taskConfig.setApproveByBusinessData(this.currentBusinessData, approve);
                }
                if (this.taskConfig.hasOwnProperty('setApproveByVariable')) {
                    let tempList = this.taskConfig.setApproveByVariable;
                    for (let temp of tempList) {
                        let variables = this.taskConfig.variables;
                        for (let i = 0; i < variables.length; i++) {
                            if (variables[i].name === temp.variableName) {
                                approve = temp.handler(approve, this.value[i]);
                                console.log('-inside-approve', approve);
                                break;
                            }
                        }
                    }
                }
            }
            return approve;
        },
        //根据approve获取指派配置
        getAssigneeMapByApprove() {
            let assigneeMap = this.taskConfig.userSelectMap;
            let arr = [];
            //搜索匹配的列表
            if (assigneeMap !== undefined) {
                let approve = this.getApprove();
                if (assigneeMap.hasOwnProperty(approve)) {
                    return assigneeMap[approve];
                } else {
                    for (let item in assigneeMap) {
                        if (assigneeMap.hasOwnProperty(item)) {
                            for (let str of item.split(",")) {
                                if (str !== '*' && Number.parseInt(str) === approve) {
                                    return assigneeMap[item];
                                }
                            }
                        }
                    }
                }
                if (assigneeMap.hasOwnProperty('*')) {
                    arr = assigneeMap['*'];//通配符
                }
            }
            //todo complete this function
            // //从next task中获取配置
            // if (false) {
            //     let taskUser = this.getNextTaskUser();
            //     console.log('taskUser', taskUser);
            //     arr.push({
            //         name: taskUser.taskId + (taskUser.isAssignee() ? '' : '_candidateUsers'),
            //         allowMulti: !taskUser.isAssignee(),
            //         require: true
            //     })
            // }
            // console.log(arr)
            return arr;
        },
        //生成指派按钮的hover显示
        generateTitle(item) {
            let temp = '';
            if (item.userList && item.userList.length > 0) {
                temp += '已选择：\n';
                for (let o of item.userList) {
                    temp += o.deptName + '-' + o.name + '\n';
                }
            } else {
                temp += '点击选择';
            }
            return temp;
        },
        //当approve改变时
        handleApproveChange() {
            this.userSelectChange();
            this.globalChangeTag();
            this.$forceUpdate();
            this.refreshTagCount++;
        },
        //指派配置同步更新
        userSelectChange() {
            let assigneeArr = this.getAssigneeMapByApprove();
            let tempList = [];
            for (let i = 0; i < assigneeArr.length; i++) {
                let temp = assigneeArr[i];
                if (i < this.userSelect.length) {
                    this.copyUserSelectItem(temp, this.userSelect[i]);
                    tempList.push(this.userSelect[i]);
                } else {
                    let tempNew = {
                        userIds: '',
                        userList: [],
                        loading: false
                    }
                    this.copyUserSelectItem(temp, tempNew);
                    tempList.push(tempNew)
                }
            }
            this.userSelect = tempList;
        },
        copyUserSelectItem(source, target) {
            target.name = source.name;
            target.label = source.label;
            target.labelWithout = source.labelWithout;
            target.deptId = source.deptId === undefined ? "" : source.deptId;
            if (target.userIds === '' || target.userList.length === 0) {
                this.initUserSelectItemData(source, target);
            }
        },
        //填充user select字段
        initUserSelectItemData(source, item) {
            if (source.initData) {
                if (!this.taskLocalVariableInit) {
                    item.loading = true;
                } else {
                    let dataName = this.getItemInitDataName(source);
                    if (this.taskLocalVariables.hasOwnProperty(dataName)) {
                        let tempList = [];
                        let users = this.taskLocalVariables[dataName].split(",");
                        for (let user of users) {
                            let u = this.userInfosMap.get(user);
                            if (u !== undefined) {
                                tempList.push(u);
                            }
                        }
                        item.userList = tempList;
                        item.userIds = this.generateUserIdStr(tempList);
                    }
                    item.loading = false;
                }
            }
        },
        //查看指派是否完成
        checkUserSelectComplete() {
            let assigneeArr = this.getAssigneeMapByApprove();
            if (assigneeArr.length > 0 && this.userSelect.length === 0) {
                return false;
            }
            for (let i = 0; i < assigneeArr.length; i++) {
                let temp = assigneeArr[i];
                if (temp.require && this.userSelect[i].userList.length === 0) {
                    return false;
                }
            }
            return true;
        },
        //拼接用户id
        generateUserIdStr(userList) {
            return this.generateUsers(userList, 'id');
        },
        //拼接用户名
        generateUserListLoginName(userList) {
            return this.generateUsers(userList, 'loginName');
        },
        generateUsers(userList, key) {
            let temp = '';
            for (let item of userList) {
                temp += ',' + item[key];
            }
            return temp.substring(1);
        },
        //获取下一任务
        getNextTaskByApprove() {
            let taskId = '';
            if (this.taskConfig.hasOwnProperty('approveToNextTask')) {
                let approveToNextTask = this.taskConfig.approveToNextTask;
                if (!(approveToNextTask instanceof Object)) {
                    taskId = approveToNextTask;
                }
                let approve = this.getApprove();
                if (approve >= 0) {
                    if (approveToNextTask.hasOwnProperty(approve)) {
                        taskId = approveToNextTask[approve];
                    }
                    let f = false;
                    for (let item in approveToNextTask) {
                        if (approveToNextTask.hasOwnProperty(item)) {
                            for (let str of item.split(",")) {
                                if (Number.parseInt(str) === approve) {
                                    taskId = approveToNextTask[item];
                                    f = true;
                                    break;
                                }
                            }
                            if (f) {
                                break;
                            }
                        }
                    }
                }
            }
            return taskId;
        },
        //获取任务名称
        getTaskNameByTaskId() {
            let name = this.nextTaskConfig.name;
            return name ? name : '';
        },
        //检查是否需要初始化人员信息
        initUserSelectMap() {
            let tempStr = "";
            let assigneeMap = this.taskConfig.userSelectMap;
            for (let key in assigneeMap) {
                if (assigneeMap.hasOwnProperty(key)) {
                    for (let item of assigneeMap[key]) {
                        let dataName = this.getItemInitDataName(item);
                        if (item.initData &&
                            this.taskLocalVariables.hasOwnProperty(dataName)) {
                            tempStr += "," + this.taskLocalVariables[dataName];
                        }
                    }
                }
            }
            this.getUserInfoByLoginName(tempStr.substring(1));
        },
        //获取initDataName
        getItemInitDataName(item) {
            return item.initDataName === undefined ? item.name : item.initDataName;
        },
        getDataFieldName(item) {
            return item.dataFieldName === undefined ? item.name : item.dataFieldName;
        },
        //根据loginName批量查询用户信息
        getUserInfoByLoginName(value) {
            let api = process.env.VUE_APP_EM_ADMIN_URL + "/emAclUser/userInfo/loginName?loginName=" + value;
            this.$_emApiMixin_get(api).then(response => {
                for (let user of response.list) {
                    this.userInfosMap.set(user.loginName, user);
                }
                this.handleApproveChange();
            })
        },
        //任务全局changeTag
        globalChangeTag() {
            if (this.taskConfig.hasOwnProperty('changeTag')) {
                this.handleTagChange(this.taskConfig.changeTag(this.currentBusinessData, this.getApprove()));
            }
        },
        //按优先级获取下一任务处理人
        getNextTaskUser() {
            const assigneeKey = 'defaultAssignee';
            const candidateUserKey = 'defaultCandidateUser';
            let res = this.checkIfHasBeforeBuild(this.nextTaskConfig, assigneeKey, candidateUserKey);
            if (res == null) {
                return this.checkIfHasBeforeBuild(this.initializedConfig, assigneeKey, candidateUserKey);
            } else {
                return res;
            }
        },
        checkIfHasBeforeBuild(config, ...keys) {
            let index = 1;
            for (let key of keys) {
                if (config.hasOwnProperty(key)) {
                    let temp = this.checkBeforeBuildNextTaskUser(config[key], index);
                    if (temp != null) {
                        return temp;
                    }
                }
                index++;
            }
            return null;
        },
        checkBeforeBuildNextTaskUser(value, type) {
            if (typeof value === "string") {
                return this.buildNextTaskUser(type, value);
            } else if (value) {
                return this.buildNextTaskUser(type, this.nextTaskId);
            }
            return null;
        },
        buildNextTaskUser(type, taskId) {
            return {
                isAssignee: () => {
                    return type === 1;
                },
                taskId: taskId
            }
        },
        //获取任务处理人字段名称
        getDefaultTaskUser() {
            let taskUser = this.getNextTaskUser();
            return taskUser.taskId + (taskUser.isAssignee() ? '_assignee' : '_candidateUsers');
        },
        //表格值改变
        tableDataChange(index, newVal) {
            // console.log('--------row list', newVal);
            // console.log('--------items', this.value[index]);
            this.value[index] = newVal;
        },
        goBackNormal() {
            this.$store.commit('workflow/setTaskListNeedRefresh', true);
            this.$router.go(-1);
        },
    }
}
</script>

<style scoped>
.mh_ {
    max-height: 1.8rem;
}

.m-auto-l-0 {
    margin: auto auto auto 0.25rem;
}
</style>
